import cx from 'classnames'

import classes from '../styles.module.scss'

type Props = {
  title: string
}

export default function TileTitle({ title }: Props) {
  return <span className={cx('mt-typography-body2', classes.title)}>{title}</span>
}
